import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { properties, CONTACT } from "@/data/site";

export default function Footer() {
  const { scrollToId } = useApp();
  const navigate = useNavigate();
  const go = (id) => { if (window.location.pathname !== "/") { navigate("/"); setTimeout(() => scrollToId(id), 350); } else scrollToId(id); };

  return (
    <footer className="bg-brand-black text-brand-ivory pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="font-heading text-xl tracking-[0.2em] uppercase">Martelli Rentals</div>
          <div className="text-xs tracking-[0.3em] uppercase opacity-60 mt-1">Italian Homes &amp; Hospitality</div>
          <p className="text-sm text-brand-ivory/60 mt-4 leading-relaxed">Soggiorni selezionati, gestiti con cura tra Abruzzo e Roma.</p>
        </div>
        <div>
          <h4 className="text-sm font-medium tracking-wide uppercase text-brand-gold mb-4">Esplora</h4>
          <ul className="space-y-2 text-sm text-brand-ivory/70">
            {[["Home", "top"], ["Strutture", "strutture"], ["Destinazioni", "destinazioni"], ["Prenota", "booking"], ["Contatti", "contatti"]].map(([l, id]) => (
              <li key={id}><button onClick={() => go(id)} className="hover:text-brand-gold transition-colors">{l}</button></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-medium tracking-wide uppercase text-brand-gold mb-4">Strutture</h4>
          <ul className="space-y-2 text-sm text-brand-ivory/70">
            {properties.map((p) => (
              <li key={p.id}><Link to={`/strutture/${p.slug}`} className="hover:text-brand-gold transition-colors">{p.name}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-medium tracking-wide uppercase text-brand-gold mb-4">Informazioni</h4>
          <ul className="space-y-2 text-sm text-brand-ivory/70">
            <li><Link to="/termini" className="hover:text-brand-gold transition-colors">Chi siamo</Link></li>
            <li><button onClick={() => go("booking")} className="hover:text-brand-gold transition-colors">FAQ</button></li>
            <li><Link to="/termini" className="hover:text-brand-gold transition-colors">Termini e condizioni</Link></li>
            <li><Link to="/privacy" className="hover:text-brand-gold transition-colors">Privacy policy</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-brand-gold transition-colors">Cookie policy</Link></li>
          </ul>
          <div className="mt-4 text-sm text-brand-ivory/70 space-y-1">
            <a href={`mailto:${CONTACT.email}`} className="block hover:text-brand-gold transition-colors break-all">{CONTACT.email}</a>
            <a href={CONTACT.instagramUrl} target="_blank" rel="noopener noreferrer" className="block hover:text-brand-gold transition-colors">@{CONTACT.instagram}</a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 pt-8 border-t border-white/10 text-center text-xs text-brand-ivory/50 space-y-1">
        <p>© {new Date().getFullYear()} Martelli Rentals. Tutti i diritti riservati.</p>
        <p>Gestione e ospitalità a cura di Lorenzo Martelli.</p>
      </div>
    </footer>
  );
}
